import { BadgeCheck, Lock, ShieldCheck, Truck } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const LABS = [
  { abbr: "GIA", name: "Gemological Institute of America", note: "The benchmark for natural diamond grading" },
  { abbr: "IGI", name: "International Gemological Institute", note: "Leading certification for lab-grown goods" },
  { abbr: "HRD", name: "HRD Antwerp", note: "European bourse-standard certification" },
];

const GUARANTEES = [
  { icon: ShieldCheck, title: "Authenticity guarantee", body: "Report numbers verified against lab databases before any stone is offered. Mismatch = no deal." },
  { icon: Truck, title: "Insured logistics", body: "Fully insured, armored door-to-door carriage on every shipment — Dubai, Mumbai, Antwerp, Hong Kong." },
  { icon: Lock, title: "JLT vault holding", body: "Memo and call-off stock held in bonded JLT vaulting with dual-control access and full audit trail." },
];

export const CertificationsTrust = () => (
  <section id="trust" data-testid="certifications-trust" className="mx-auto max-w-7xl px-6 py-24 lg:px-12 lg:py-32">
    <Reveal>
      <p className="eyebrow mb-4">Certifications & Trust</p>
      <h2 className="font-display max-w-2xl text-3xl font-light leading-snug tracking-tight text-white sm:text-4xl lg:text-5xl">
        Papered. Verified. <span className="gold-text italic">Guaranteed.</span>
      </h2>
    </Reveal>

    <div className="mt-14 grid gap-6 md:grid-cols-3">
      {LABS.map((lab, i) => (
        <Reveal key={lab.abbr} delay={i * 0.1}>
          <div
            data-testid={`trust-lab-${lab.abbr.toLowerCase()}`}
            className="glass-panel group rounded-2xl p-8 text-center transition-all duration-500 hover:border-[#C9A24B]/40"
          >
            <div className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border border-[#C9A24B]/40 bg-[#C9A24B]/5 transition-all duration-500 group-hover:shadow-[0_0_30px_rgba(201,162,75,0.3)]">
              <span className="font-display text-2xl font-medium tracking-widest gold-text">{lab.abbr}</span>
            </div>
            <h3 className="mt-5 text-sm font-semibold tracking-wide text-white">{lab.name}</h3>
            <p className="mt-2 text-xs leading-relaxed text-[#717680]">{lab.note}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <div className="mt-6 grid gap-6 md:grid-cols-3">
      {GUARANTEES.map((g, i) => (
        <Reveal key={g.title} delay={0.1 + i * 0.1}>
          <div data-testid={`trust-guarantee-${i}`} className="rounded-2xl border border-white/10 bg-[#141418] p-8">
            <g.icon className="mb-4 h-5 w-5 text-[#C9A24B]" strokeWidth={1.5} />
            <h3 className="font-display text-xl text-white">{g.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-[#B8BCC2]">{g.body}</p>
          </div>
        </Reveal>
      ))}
    </div>

    <Reveal delay={0.2}>
      <p className="mt-10 flex items-center justify-center gap-2 text-center text-[11px] uppercase tracking-[0.2em] text-[#717680]" data-testid="trust-note">
        <BadgeCheck className="h-4 w-4 text-[#C9A24B]" />
        Every certified stone ships with original lab papers and inscription match
      </p>
    </Reveal>
  </section>
);
